// extracted by mini-css-extract-plugin
module.exports = {"caseCard":"CaseCard_caseCard__5sknY","header":"CaseCard_header__1iZi-","rename":"CaseCard_rename__1OeNi","delete":"CaseCard_delete__ECFWb","content":"CaseCard_content__3AHaD"};